import { Fieldset, Heading, Paragraph, Radio } from '@digdir/designsystemet-react';
import { useTranslation } from 'react-i18next';

import { SummaryCard } from '../../../../../expertRegistration/json/common/summary/styledComponents';
import { Malform } from '../../../../../../components/registering/utils/registerEnums';
import { useVisningsOgDelingFormContext } from '../../utils';

export const StandardLanguagePicker = ({ disabled }: { disabled?: boolean }) => {
  const { t } = useTranslation('', { keyPrefix: 'form.samtykke.maalform' });
  const { register } = useVisningsOgDelingFormContext();

  return (
    <SummaryCard>
      <Fieldset disabled={disabled}>
        <Fieldset.Legend>
          <Heading level={4}>{t('header')}</Heading>
        </Fieldset.Legend>
        <Fieldset.Legend>
          <Paragraph data-size="sm">{t('previewHeader')}</Paragraph>
        </Fieldset.Legend>
        <Radio {...register('maalform')} label={t('bokmal')} value={Malform.Bokmal} />
        <Radio {...register('maalform')} label={t('nynorsk')} value={Malform.Nynorsk} />
      </Fieldset>
    </SummaryCard>
  );
};
